import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CountdownModule } from 'ngx-countdown';
import { CountdownComponent } from './countdown.component';

@NgModule({
  imports: [CommonModule, CountdownModule],
  declarations: [CountdownComponent],
  exports: [CountdownComponent],
})
export class SharedUiCountdownModule {}
